<template>
    <div class="nav-panel-meta grid grid__base">
        <div class="grid--container">
            <div class="grid--row">
                <div class="grid--col">
                    <lang-list class="nav-panel-meta--lang-list" :languages="languages" />
                    <ul class="u-reset nav-panel-meta--list">
                        <li class="nav-panel-meta--list-item" v-for="(link, idx) in links" :key="idx">
                            <a class="u-reset nav-panel-meta--link" :href="link.path">{{ link.label }}</a>
                        </li>
                    </ul>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    import LangList from 'framework/components/lang-list/lang-list';

    export default {
        components: { LangList },
        props: {
            /** @type {ILink[]} */
            links: {
                type: Array,
                default: () => [],
            },

            /** @type {ILink[]} */
            languages: {
                type: Array,
                default: () => [],
            },
        },
    };
</script>
